"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventStreamSerdeProvider = exports.EventStreamMarshaller = void 0;
var event_streams_1 = require("@smithy/core/event-streams");
Object.defineProperty(exports, "EventStreamMarshaller", { enumerable: true, get: function () { return event_streams_1.EventStreamMarshaller; } });
Object.defineProperty(exports, "eventStreamSerdeProvider", { enumerable: true, get: function () { return event_streams_1.eventStreamSerdeProvider; } });
